import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { ScrollView } from "react-native";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import {
  UpdateEmailOrPhoneProfileCloseActionAtom,
  UpdateEmailOrPhoneProfileCompleteActionAtom,
} from "../atoms/stores";
import { UpdateEmailOrPhoneProfileBody } from "./UpdateEmailOrPhoneProfileBody";
import { UpdateEmailOrPhoneProfileHeader } from "./UpdateEmailOrPhoneProfileHeader";

type Props = {
  defaultCountryCodeId: string;
  onClose: () => void;
  onComplete: () => void;
  updateEmailOrPhone: "phone" | "email" | null;
};

export const UpdateEmailOrPhoneProfile = ({
  defaultCountryCodeId,
  onClose,
  onComplete,
  updateEmailOrPhone,
}: Props) => {
  const setUpdateEmailOrPhoneProfileCloseAction = useSetAtom(
    UpdateEmailOrPhoneProfileCloseActionAtom
  );
  const setUpdateEmailOrPhoneProfileCompleteAction = useSetAtom(
    UpdateEmailOrPhoneProfileCompleteActionAtom
  );
  useEffect(() => {
    setUpdateEmailOrPhoneProfileCloseAction(() => {
      return onClose;
    });
    setUpdateEmailOrPhoneProfileCompleteAction(() => {
      return onComplete;
    });
  }, [
    onClose,
    onComplete,
    setUpdateEmailOrPhoneProfileCloseAction,
    setUpdateEmailOrPhoneProfileCompleteAction,
  ]);
  return (
    <VStack flex={1}>
      <UpdateEmailOrPhoneProfileHeader onClose={onClose} />
      <ScrollView style={{ flex: 1 }}>
        <UpdateEmailOrPhoneProfileBody
          defaultCountryCodeId={defaultCountryCodeId}
          updateEmailOrPhone={updateEmailOrPhone}
        />
      </ScrollView>
    </VStack>
  );
};
